import { useDispatchAction } from '../../components/ActionButtons/dispatch/DispatchAction';
import { createBackgroundJob } from '../../utils/BackgroundJobs';
import getClientMutationId from '../../utils/getClientMutationId';
import { useActionProps } from '../../utils/useActionProps';
import { useContext } from 'react';
import WorkspaceContext from '../../components/Context/WorkspaceContext';
import { DocumentNode } from '@apollo/client';
import { DispatchSource } from '../../components/ActionButtons/dispatch/DispatchModal';

export const workspace = [
  {
    actionReference: 'IMPORTED_ORDERS_RETRY',
  },
];

export const useImportedOrderWorkspaceActions = ({
  retryMutation,
  type,
  dispatchSource,
}: {
  retryMutation: DocumentNode;
  type: string;
  dispatchSource: DispatchSource;
}) => {
  const workspaceContext = useContext(WorkspaceContext);

  const [dispatchActionButton, printModals] = useDispatchAction({
    source: dispatchSource,
  });

  const actionProps = useActionProps(type);

  const preparePayload = () => {
    return {
      clientMutationId: getClientMutationId(),
      ...actionProps,
    };
  };

  const retryImport = (props: any) => {
    const input = preparePayload();

    //TODO - Update to 'useBackgroundMutation'
    createBackgroundJob(retryMutation, input, props, null, 'Retrying import', (job) => {
      if (job.complete) {
        workspaceContext.reloadData?.();
      }
    });
  };

  return [
    [
      {
        description: 'Retry',
        call: retryImport,
        dataFromProps: 'actionEntities',
        actionReference: 'IMPORTED_ORDERS_RETRY',
      },
      dispatchActionButton,
    ],
    printModals,
  ];
};
